import {
    GetFlightRequestActionTypes,
    GET_FLIGHT_REQUEST_SUCCESS,
    GET_FLIGHT_REQUEST_CLEAR,
    GET_FLIGHT_REQUEST_FAILURE,
    APPROVE_FLIGHT_REQUEST_SUCCESS,
    APPROVE_FLIGHT_REQUEST_FAILURE,
    APPROVE_FLIGHT_REQUEST_CLEAR,
    SAVE_FLIGHT_REQUEST_CLEAR,
    SAVE_FLIGHT_REQUEST_SUCCESS,
    SAVE_FLIGHT_REQUEST_FAILURE,
    REJECT_FLIGHT_REQUEST_CLEAR,
    REJECT_FLIGHT_REQUEST_SUCCESS,
    REJECT_FLIGHT_REQUEST_FAILURE,
    OFFER_FLIGHT_REQUEST_SUCCESS,
    OFFER_FLIGHT_REQUEST_FAILURE,
    OFFER_FLIGHT_REQUEST_CLEAR,
    SUBMIT_OFFER_FLIGHT_REQUEST_SUCCESS,
    SUBMIT_OFFER_FLIGHT_REQUEST_FAILURE,
    SUBMIT_OFFER_FLIGHT_REQUEST_CLEAR,
} from './types';

export function getFlightRequest(state = {}, action: GetFlightRequestActionTypes) {
    switch (action.type) {
        case GET_FLIGHT_REQUEST_SUCCESS:
            return action.payload;
        case GET_FLIGHT_REQUEST_FAILURE:
            return action.payload;
        case GET_FLIGHT_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function approveFlightRequest(state = [], action: GetFlightRequestActionTypes) {
    switch (action.type) {
        case APPROVE_FLIGHT_REQUEST_SUCCESS:
            return action.payload;
        case APPROVE_FLIGHT_REQUEST_FAILURE:
            return action.payload;
        case APPROVE_FLIGHT_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function saveFlightRequest(state = [], action: GetFlightRequestActionTypes) {
    switch (action.type) {
        case SAVE_FLIGHT_REQUEST_SUCCESS:
            return action.payload;
        case SAVE_FLIGHT_REQUEST_FAILURE:
            return action.payload;
        case SAVE_FLIGHT_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function rejectFlightRequest(state = [], action: GetFlightRequestActionTypes) {
    switch (action.type) {
        case REJECT_FLIGHT_REQUEST_SUCCESS:
            return action.payload;
        case REJECT_FLIGHT_REQUEST_FAILURE:
            return action.payload;
        case REJECT_FLIGHT_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function offerFlightRequest(state = [], action: GetFlightRequestActionTypes) {
    switch (action.type) {
        case OFFER_FLIGHT_REQUEST_SUCCESS:
            return action.payload;
        case OFFER_FLIGHT_REQUEST_FAILURE:
            return action.payload;
        case OFFER_FLIGHT_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}

export function submitOffferFlightRequest(state = [], action: GetFlightRequestActionTypes) {
    switch (action.type) {
        case SUBMIT_OFFER_FLIGHT_REQUEST_SUCCESS:
            return action.payload;
        case SUBMIT_OFFER_FLIGHT_REQUEST_FAILURE:
            return action.payload;
        case SUBMIT_OFFER_FLIGHT_REQUEST_CLEAR:
            return action.payload;
        default:
            return state;
    }
}